import { AppstoreAddOutlined, CheckCircleOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import "../CompanyManagement/CustomerManagement.css";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { useTranslation } from 'react-i18next'; // Ekleyin
import { IInventoryStatusData } from "../../../interfaces/IInventoryStatusData";
import i18n from "../../../i18n";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";

export interface IInventoryStatus {
  count?: number;
  data?: IInventoryStatusData[];
}

const InventoryStatusManagement: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const { t } = useTranslation();
  const loader = new StateLoader();
  const [inventoryStatusData, setInventoryStatusData] = useState<IInventoryStatus>({});
  const userInfo: IAuthentication = loader.loadAuthState();
  const dataGridRef = useRef<any>(null);
  const toast = useRef<any>(null);

  const pageData: IPageData = {
    title: t('inventory_status_management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);

  const isAltisAdmin = userInfo?.role === UserRole.AltisAdmin;

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      placeHolder: t('Company Name'),
      isSorting: true,
    }] : []),
    { title: t('inventory_status_name'), isSorting: true, key: 'inventoryStatusName', placeHolder: t('inventory_status_name'), align: 'center', headerAlign: 'center' },
    { title: t('inventory_status_count'),hideColumnMenu:true, isSorting: true, key: 'statusCount', placeHolder: t('inventory_status_count'), align: 'center', headerAlign: 'center'},
    {
      title: t('operations'),
      key: 'operations',
      isSorting: false,
      hideColumnMenu: true,
      placeHolder: t('operations'),
      align: 'center',
      headerAlign: 'center',
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',marginTop:10 }}>
          <Space size={8}>
            <Popconfirm
              title={<div>{t('are_you_sure')} <br /></div>}
              onConfirm={() => DeleteInventoryStatus(record.inventoryStatusId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')} placement="top">
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  onClick={(e) => { e.stopPropagation(); }}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                >
                </Button>
              </Tooltip>

            </Popconfirm>
            <Tooltip title={t('update')} placement="top">
              <Button
                size='small'
                icon={<EditOutlined />}
                onClick={() => window.location.replace('/admin/update-inventory-status/' + record.inventoryStatusId)}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              >
              </Button>
            </Tooltip>

          </Space>
        </div>
      ),
    }
  ];

  const InventoryStatusFilter = (e?) => {
    const filters = e?.filters;
    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      inventoryStatusName: filters?.inventoryStatusName,
      companyName: filters?.companyName,
    };

    HTTPService.POST(`/InventoryStatus/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setInventoryStatusData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };



  const DeleteInventoryStatus = (Id) => {
    HTTPService.DELETE(`/InventoryStatus/deleteInventoryStatus?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData()
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">
          <Button
            type="primary"
            shape="round"
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            hidden={userInfo.role === UserRole.Sayman}
            icon={<CheckCircleOutlined style={{ fontSize: 24 }} />}
            onClick={() => window.location.replace('/admin/add-inventory-status')}
          >
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('add_new_inventory_status')}
            </span>
          </Button>

        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className='table-container'>
            <MUIDatagrid ref={dataGridRef} data={inventoryStatusData.data} total={inventoryStatusData.count} columns={columns} filterMode="server" onChange={InventoryStatusFilter} />
          </div>
        </div>
      </div>
    </>
  );
};

export default InventoryStatusManagement;
